import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './ServicePackagesEditorV2.html?raw';

import MainCatalogsEditorBaseV2 from '../MainCatalogsEditorBaseV2';
import { MainCatalogs_Classes, MainCatalogTypes } from "../../_loadingHelpers/MainCatalogTypes";
import lang from 'dojo/_base/lang';
import StaticTable from '../../../moreCore/UI/StaticTable/StaticTable';
import ServicePackagesPositionsEditor from './ServicePackagesPositions/ServicePackagesPositionsEditor';
import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';
import HintBox from '../../../moreCore/UI/HintBox/HintBox';
import _GlobalSelectEntityDialogsMixin from '../../_loadingHelpers/_GlobalSelectEntityDialogsMixin';
import { SelectEntityDialogTypes } from "../../../moreCore/_loadingHelpers/SelectEntityDialog";
import { ExpandableSection, ExpandableSectionMarkings } from "../../../moreCore/UI/Container/ExpandableSectionTypes";





interface EvServiceEntry {
    serviceID: string;
    serviceColor: more.EntityAPIColor;
    assignmentID: string;
    description: string;
    service_type: number;
    $service_type: string;
    quantity: number;
    quantity_multiplier: number;
    isDeleted?: boolean;
    blobNode?: HTMLElement;
    blobIcon?: HTMLElement;
}
interface EvServiceData {
    ID: string;
    description: string;
    quantity: number;
    quantity_multiplier: number;
    service_type: number;
    $service_type: string;
    coloration: any;
}
class ServicePackagesEditorV2 extends compose(MainCatalogsEditorBaseV2, _GlobalSelectEntityDialogsMixin) {
    templateString: any = template;

    private inputEvService: MdsLax<InstanceType<typeof HintBox>>;
    private inputServicesContainer: HTMLElement;
    private selectedServicesContainer: HTMLElement;
    private tableContainer: HTMLElement;

    private selectedServices: Array<EvServiceEntry> = [];

    private originalPackages;

    private positionsTable: MdsLax<InstanceType<typeof StaticTable>> = null;
    private positionsTableLayout: any = null;
    private positionsEditor: MdsLax<InstanceType<typeof ServicePackagesPositionsEditor>> = null;
    private positionChangedData: {} = null;
    private dlg: MdsLax<InstanceType<typeof GenericDialog>> = null;

    private expanderEvServices: MdsLax<InstanceType<typeof ExpandableSection>>;

    isValid(): boolean {
        //Need to implement
        return true;
    }

    protected afterSetData(): void {
        super.afterSetData.apply(this, arguments as any);

        this.selectedServices = lang.clone(this.getAttributeValue("evServices"));
    }

    private updatePositionsTable() {

        let selectedServices: Array<EvServiceEntry> = lang.clone(this.getAttributeValue("evServices"));

        selectedServices?.length > 0 ? this.expanderEvServices.setMarking(ExpandableSectionMarkings.hasContent) : this.expanderEvServices.setMarking(ExpandableSectionMarkings.default);

        this.positionsTable.setData(selectedServices);

        selectedServices?.forEach(s => {
            if (s.isDeleted === true) {
                this.disableNode(this.positionsTable.getRowGroupByKeyValue(s.serviceID, "serviceID").rows[0].node);
            }
            if (s.service_type !== 1) {
                this.positionsTable.getRowGroupByKeyValue(s.serviceID, "serviceID").rows[0]
                    .cells.filter(x => x.valuepath == "quantity_multiplier" || x.valuepath == "quantity")
                    .forEach(c => { c.tableCellNode.textContent = "-" });
            }
        })
    }

    private _onRowClick(row: StaticTable.StaticTableRow<EvServiceEntry>, rowLine, evt: any) {

        if (evt.target.className == "actionsColumn") return;

        let entity: EvServiceEntry = row.rowGroup.entity;
        if (entity.service_type !== 1) {
            this.showToast({
                iconClass: "fas fa-info-circle",
                title: "Dieser VA_Leistung-Typ kann nicht bearbeitet werden!",
                timeout: 2000
            })
            return;
        }
        this.positionChangedData = null;

        if (this.dlg != null) this.dlg.destroy();
        if (this.positionsEditor != null) this.positionsEditor.destroy();

        this.dlg = new GenericDialog();
        this.positionsEditor = new ServicePackagesPositionsEditor();

        this.positionsEditor.setData(entity);
        this.positionsEditor.on("ServicePackagesPositions_ChacgedData", (cd) => { this.positionChangedData = cd; });

        this.dlg.show(this.positionsEditor, entity.description, null, null, "okcancel", lang.hitch(this, this.processPositionNewData, entity), { closeOnEscape: true, size: "smaller" });
    }

    private processPositionNewData(entity: EvServiceEntry, dlgResult: Number) {

        if (dlgResult === 0 && this.positionChangedData === null) return;

        let i = 0;
        for (let e of this.selectedServices) {
            if (e.serviceID === entity.serviceID) break;
            i++;
        }

        for (let p in this.positionChangedData){

            switch (p) {

                default:
                    this.selectedServices[i][p] = this.positionChangedData[p]
            }
        }

        this.setAttributeValue("evServices", lang.clone(this.selectedServices));
        this.updatePositionsTable();
    }

    private removeService(rowGr: StaticTable.StaticTableRowGroup<EvServiceEntry>) {
        
        let entry = rowGr.entity;
        let deletedCategory = this.selectedServices.filter(x => x.serviceID === entry.serviceID)[0];

        if (entry.assignmentID == null) {

            this.selectedServices.splice(this.selectedServices.indexOf(deletedCategory), 1);
        } else {

            deletedCategory.isDeleted = true;
        }

        this.setAttributeValue("evServices", lang.clone(this.selectedServices));
        this.updatePositionsTable();
    }

    protected _setEntityClass(): void {
        //You need to set this to Entity class of the editor
        this.entityClass = MainCatalogs_Classes.ServicePackage;
    }

    private _onChangeService(): void {
        let value = this.inputEvService.getValue() as EvServiceData;

        this.addNewEntry(value);

        this.inputEvService.setValue(null, true);
    }

    private addNewEntry(value: EvServiceData) {

        if (value == null) return;

        let existingEntry = this.selectedServices.filter(x => x.serviceID === value.ID)[0];
        if (existingEntry && existingEntry.isDeleted !== true) {
            //this.showToast(`${value.description} allready in list!`);
            this.showToast({
                title: this.translate("MainCatalogsEditor_ServicePackages_Toast_ExistInList"),
                message: `**${value.description}**  ${this.translate("MainCatalogsEditor_ServicePackages_Toast_ExistInList_details")}`,
                messageIcon: "fas fa-info-circle",
                iconClass: "fas fa-info-circle"
            })
            return;
        }

        if (existingEntry && existingEntry.isDeleted === true) {

            existingEntry.isDeleted = false;
            this.setAttributeValue("evServices", lang.clone(this.selectedServices));
            this.updatePositionsTable();
            return;
        }

        let fakeEntry: EvServiceEntry = {
            assignmentID: null,
            serviceID: value.ID,
            service_type: value.service_type,
            $service_type: value.$service_type,
            quantity_multiplier: value.service_type === 1 ? value.quantity_multiplier : null,
            quantity: value.service_type === 1 ? value.quantity : null,
            //quantity: value.quantity,
            //quantity_multiplier: value.quantity_multiplier ? value.quantity_multiplier : 1,
            description: value.description,
            serviceColor: value.coloration
        }

        this.selectedServices.push(fakeEntry);
        this.setAttributeValue("evServices", lang.clone(this.selectedServices));

        this.updatePositionsTable();
    }

    private _onClick_OpenEvServicesSED(evt) {
        this.loadSelectEntityDialog(evt,
            "selectEvServices",
            lang.hitch(this, this._onCallback_Dlg)
        );
    }
    private _onCallback_Dlg(mode: string, data, items: Array<SelectEntityDialogTypes.Item<EvServiceData>>) {
        // fake-entity falls das zurückgeleiferte Entity aus items[0].entry.data nicht dem entspricht das die liste erwartet
        
        if (!items || !items.length) return;
        if (mode == "selectEvServices") {
            for (let item of items) {

                let entity: Partial<EvServiceData> = item.entry?.data;

                if (!entity) {
                    entity = {
                        ID: item.entry.value, description: item.entry.label
                    };
                }

                this.addNewEntry(entity as any);
            }
        }
    }
    private _setUpTable(response: { layouts: Array<any> }) {
        console.debug(response);
        if (this.positionsTable != null) this.positionsTable.destroy();

        this.positionsTable = new StaticTable();
        this.positionsTable.placeAt(this.tableContainer);

        this.positionsTable.setLayout(response.layouts[0]);
        this.positionsTable.addDefaultRowActionButton("delete", lang.hitch(this, this.removeService));
        //this.positionsTable.addCustomRowActionButton("deleteService", lang.hitch(this, this.removeService), "fas fa-bin w3-large");

        this.positionsTable.setRowClick(lang.hitch(this, this._onRowClick))
        this.positionsTable.setCyAttribute("ServicePackagesEditorV2PositionsTable");
        this.updatePositionsTable();
    }
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.inputEvService.addInlineButton(lang.hitch(this, this._onClick_OpenEvServicesSED));
        this.SEDconfigCallfunction = "Webtool_API_MainCatalogsEditor__SED_GetConfig";
    }

    startup(): void {
        super.startup.apply(this, arguments as any);

        this.RequestManager.callfunction(
            "Webtool__MainCatalogsEditor_GetEvServicePackagePositionsTable",
            null,
            lang.hitch(this, this._setUpTable),
            (err) => { this.showToast(err.Message) }
        )
    }
}

export default mdsWidget(ServicePackagesEditorV2);